<template>
  <div :id="'cont_' + formProperty.nativename">
  </div>
</template>
<script>

import {StaticData} from "src/classes/StaticData";

export default {
  props: [
    'formProperty'
  ],
  components: {},
  data() {
    return {
      value: null,
      parentElement: null,
    }
  },

  methods: {

    appendScript() {
      setTimeout(() => {
        if (this.value) {
          let src = this.value.replace("script://", "")
          let newScriptElementUsingSource = document.createElement('script')
          newScriptElementUsingSource.setAttribute('type', 'text/javascript')
          newScriptElementUsingSource.appendChild(document.createTextNode(src))
          this.parentElement.appendChild(newScriptElementUsingSource)
        }
      }, 100)
    },

    removeChilds() {
      while (this.parentElement.firstChild) {
        this.parentElement.removeChild(this.parentElement.firstChild);
      }
    },

    onChange(value) {
    },

    onRefreshComp(data) {
      if (this.formProperty.nativename === data.nativename) {
        if (this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.value = data.value
          this.appendScript()
        } else {
          this.removeChilds()
        }
      }
    },

    getValue() {
      let result = null
      if (this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
        result = this.formProperty.value ? this.formProperty.value : this.formProperty.propertyInstanceValue
      }
      return result
    }
  },

  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
  },

  mounted: function () {
    this.eventBus.on('onRefreshComp', this.onRefreshComp)

    let sParent = "cont_" + this.formProperty.nativename
    this.parentElement = document.getElementById(sParent)
    this.value = this.getValue()

    // console.log("Mount fldScript:", this.formProperty.title, this.formProperty.propertyInstanceValue)
    this.appendScript()
  }
}
</script>

